import { useTranslations } from "@/lib/i18n/intl";
import { useLocale } from "@admin/app/locale";
import { keys } from "@/lib/i18n/portal";
import { useFeatureFlagAuditQuery } from "../services/useFeatureFlagAuditQuery";

type Props = {
  flagId: string;
};

export function FeatureFlagAuditPanel({ flagId }: Props) {
  const t = useTranslations();
  const locale = useLocale();
  const { data, isLoading } = useFeatureFlagAuditQuery(flagId, true);

  if (isLoading) {
    return (
      <p className="text-xs text-[color:var(--text-muted)]">
        {t(keys.common.loading)}
      </p>
    );
  }
  if (!data || data.length === 0) {
    return (
      <p className="text-xs text-[color:var(--text-muted)]">
        {t(keys.featureFlags.historyEmpty)}
      </p>
    );
  }
  return (
    <ul className="flex flex-col gap-1.5 text-xs">
      {data.map((entry) => (
        <li
          key={entry.id}
          className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5 text-[color:var(--text-secondary)]"
        >
          <span className="font-mono text-[10px] text-[color:var(--text-muted)]">
            {formatTimestamp(entry.changedAt, locale)}
          </span>
          <span className="font-semibold">{entry.action}</span>
          {entry.detail ? (
            <span className="text-[color:var(--text-muted)]">
              {entry.detail}
            </span>
          ) : null}
          {entry.actorEmail ? (
            <span className="text-[10px] text-[color:var(--text-muted)]">
              {entry.actorEmail}
            </span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}

function formatTimestamp(iso: string, locale: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString(locale);
}
